import { h as ht } from './index.es-b80b758c.js';

const errors$1 = {
	required: "This field is required.",
	date: {
		badInput: "The date format must be {pattern}",
		min: "The date cannot be earlier than {min}",
		max: "The date cannot be later than {max}",
		minMax: "The date must be between {min} and {max}"
	},
	numeric: {
		min: "The value cannot be less than {min}",
		max: "The value cannot be greater than {max}",
		minMax: "The value must be between {min} and {max}"
	}
};
const nbCharLeft$1 = "{counter} characters left.";
const input$1 = {
	select: {
		placeholder: "Select a value"
	},
	checkbox: {
		selectedValues: "{nb} selected values",
		selectedValue: "{nb} selected value",
		editButton: "Edit",
		selectButton: "Select values",
		showButton: "Show",
		label: "Enter a value",
		result: "result",
		results: "results",
		searchResults: "Search result(s) list.",
		noResult: "No result.",
		sections: {
			selected: {
				title: "Selected",
				titlePlurial: "Selected",
				action: "Unselect all",
				tooltip: "Unselect all current search results"
			},
			notSelected: {
				title: "Not selected",
				titlePlurial: "Not selected",
				action: "Select all",
				tooltip: "Select all current search results"
			}
		}
	},
	date: {
		helpText: "Expected format: {pattern} (ex: {date})",
		pattern: {
			dd: "dd",
			mm: "mm",
			yyyy: "yyyy"
		}
	},
	password: {
		display: "Display password value",
		hide: "Hide password value"
	}
};
const form$1 = {
	required: "Fields with a <strong class=\"mg-u-is-asterisk\">*</strong> are required",
	requiredSingle: "Field with a <strong class=\"mg-u-is-asterisk\">*</strong> is required",
	allRequired: "All fields are required",
	allRequiredSingle: "The field is required"
};
const alert$1 = {
	closeButton: "Close message"
};
const modal$1 = {
	closeButton: "Close modal"
};
const pagination$1 = {
	label: "Pagination",
	page: "page",
	pages: "pages",
	nextPage: "Next page",
	previousPage: "Previous page",
	selectPage: "Select the page to display."
};
const panel$1 = {
	editLabel: "Edit section title."
};
const skipLinks$1 = {
	navLabel: "Quick access"
};
const general$1 = {
	confirm: "Confirm",
	cancel: "Cancel",
	close: "Close",
	next: "next",
	previous: "previous"
};
const menuItem$1 = {
	badgeLabel: "Include notification(s)",
	openNewTab: "Open link in a new tab"
};
const itemMore$1 = {
	menuLabel: "Additional menu"
};
const actionMore$1 = {
	label: "Actions"
};
const loader$1 = {
	inProgess: "Loading in progress…"
};
const en = {
	errors: errors$1,
	nbCharLeft: nbCharLeft$1,
	input: input$1,
	form: form$1,
	alert: alert$1,
	modal: modal$1,
	pagination: pagination$1,
	panel: panel$1,
	skipLinks: skipLinks$1,
	general: general$1,
	menuItem: menuItem$1,
	itemMore: itemMore$1,
	actionMore: actionMore$1,
	loader: loader$1
};

const errors = {
	required: "Ce champ est obligatoire.",
	date: {
		badInput: "Le format de la date doit être du type {pattern}",
		min: "La date ne peut pas être antérieure au {min}",
		max: "La date ne peut pas être postérieure au {max}",
		minMax: "La date doit être comprise entre le {min} et le {max}"
	},
	numeric: {
		min: "La valeur ne peut pas être inférieure à {min}",
		max: "La valeur ne peut pas être supérieure à {max}",
		minMax: "La valeur doit être comprise entre {min} et {max}"
	}
};
const nbCharLeft = "{counter} caractères disponibles.";
const input = {
	select: {
		placeholder: "Sélectionnez une valeur"
	},
	checkbox: {
		selectedValues: "{nb} valeurs selectionnées",
		selectedValue: "{nb} valeur selectionnée",
		editButton: "Modifier",
		selectButton: "Sélectionner des valeurs",
		showButton: "Voir",
		label: "Saisissez une valeur",
		result: "résultat",
		results: "résultats",
		searchResults: "List de résultat(s) de la recherche.",
		noResult: "Aucun résultat.",
		sections: {
			selected: {
				title: "Sélectionné",
				titlePlurial: "Sélectionnés",
				action: "Tout désélectionner",
				tooltip: "Désélectionne tous les résultats de la recherche en cours"
			},
			notSelected: {
				title: "Non sélectionné",
				titlePlurial: "Non sélectionnés",
				action: "Tout sélectionner",
				tooltip: "Sélectionne tous les résultats de la recherche en cours"
			}
		}
	},
	date: {
		helpText: "Format attendu&nbsp;: {pattern} (ex&nbsp;: {date})",
		pattern: {
			dd: "jj",
			mm: "mm",
			yyyy: "aaaa"
		}
	},
	password: {
		display: "Afficher le mot de passe",
		hide: "Masquer le mot de passe"
	}
};
const form = {
	required: "Les champs marqués d'un <strong class=\"mg-u-is-asterisk\">*</strong> sont obligatoires",
	requiredSingle: "Le champ marqué d'un <strong class=\"mg-u-is-asterisk\">*</strong> est obligatoire",
	allRequired: "Tous les champs sont obligatoires",
	allRequiredSingle: "Le champ est obligatoire"
};
const alert = {
	closeButton: "Fermer le message"
};
const modal = {
	closeButton: "Fermer la modale"
};
const pagination = {
	label: "Pagination",
	page: "page",
	pages: "pages",
	nextPage: "Page suivante",
	previousPage: "Page précédente",
	selectPage: "Sélectionner la page à afficher."
};
const panel = {
	editLabel: "Modifier le titre de la section."
};
const skipLinks = {
	navLabel: "Accès rapide"
};
const general = {
	confirm: "Valider",
	cancel: "Annuler",
	close: "Fermer",
	next: "suivant",
	previous: "précédent"
};
const menuItem = {
	badgeLabel: "Notification(s) incluse(s)",
	openNewTab: "Ouvrir le lien dans un nouvel onglet"
};
const itemMore = {
	menuLabel: "Menu complémentaire"
};
const actionMore = {
	label: "Actions"
};
const loader = {
	inProgess: "Chargement en cours…"
};
const fr = {
	errors: errors,
	nbCharLeft: nbCharLeft,
	input: input,
	form: form,
	alert: alert,
	modal: modal,
	pagination: pagination,
	panel: panel,
	skipLinks: skipLinks,
	general: general,
	menuItem: menuItem,
	itemMore: itemMore,
	actionMore: actionMore,
	loader: loader
};

const defaultLocale = 'en';
const messages = { en, fr };
/**
 * Get Intl object
 * @param element - element we need to get the language
 * @returns messages object
 */
const initLocales = ht(messages, defaultLocale);

export { initLocales as i };

//# sourceMappingURL=index-6b7bdd63.js.map